<div #textBox class="floating-text-entry">
    <textarea #input [(ngModel)]="currentText"></textarea>
    <p #p>{{currentText}}&nbsp;</p>
</div>
